export default __webpack_public_path__ + "static/media/data-loader.ffc3bc3e.svg";